import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TGpsrApi } from './types';

export const gpsr: TGpsrApi = {
	regParseGpsr: (payload) =>
		http.post(endpoint.gpsr.REG_PARSE, payload).then((response) => response.data),
	registerGpsr: (payload) => http.post(endpoint.gpsr.REGISTER, payload),
	getGpsrPlans: () => http.get(endpoint.gpsr.GET_PLANS).then((response) => response.data),
	getGpsrServiceStatuses: () =>
		http.get(endpoint.gpsr.SERVICE_STATUSES).then((response) => response.data),
	editGpsrCustomer: (payload) => http.post(endpoint.gpsr.REGISTER, payload),
	getGpsrItems: (payload) =>
		http.post(endpoint.gpsr.GPSR_ITEMS, payload).then((response) => response.data),
	getGpsrProductTypes: (params) =>
		http
			.get(endpoint.gpsr.GET_PRODUCT_TYPES(params.emId), { params })
			.then((response) => response.data),
	generateInvoiceGpsr: (params) => http.post(endpoint.gpsr.GENERATE_INVOICE(params.invoiceId)),
	getGpsrRegulations: (params) =>
		http
			.get(endpoint.gpsr.GET_REGULATIONS(params.emId, params.productTypeId))
			.then((response) => response.data),
	addGpsrProductType: (payload) =>
		http.post(endpoint.gpsr.ADD_PRODUCT_TYPE(payload.emId), payload.body),
	deleteGpsrProductType: (payload) =>
		http.delete(endpoint.gpsr.DELETE_PRODUCT_TYPE(payload.emId, payload.productTypeId)),
	addGpsrRegulations: (payload) =>
		http.post(endpoint.gpsr.ADD_REGULATION(payload.emId, payload.productTypeId), payload.body),
	deleteGpsrRegulations: (payload) =>
		http.delete(
			endpoint.gpsr.DELETE_REGULATION(payload.emId, payload.productTypeId, payload.regulationId),
		),
	getProductTypeReferences: (payload) =>
		http.post(endpoint.gpsr.GET_PRODUCT_TYPE_REFERENCES, payload).then((response) => response.data),
	getProductTypeRegulationsGroupTypes: (payload) =>
		http
			.post(endpoint.gpsr.GET_PRODUCT_TYPE_REGULATIONS_GROUP_TYPES, payload)
			.then((response) => response.data),
	getProductTypeRegulationsReferences: (payload) =>
		http
			.post(endpoint.gpsr.GET_PRODUCT_TYPE_REGULATIONS_REFERENCES, payload)
			.then((response) => response.data),
	getRegulationsReferences: (payload) =>
		http.post(endpoint.gpsr.GET_REGULATIONS_REFERENCES, payload).then((response) => response.data),
	getTechFile: (payload) =>
		http
			.get(endpoint.gpsr.GET_TECH_FILE(payload.emId, payload.productTypeId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getDocFile: (payload) =>
		http
			.get(endpoint.gpsr.GET_D_O_C_FILE(payload.emId, payload.productTypeId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	cancelGpsr: (id) => http.post(endpoint.gpsr.CANCEL_GPSR(id)),
	activateGpsr: (id) => http.post(endpoint.gpsr.ACTIVATE_GPSR(id)),
	changeGpsrStatus: (payload) =>
		http
			.post(endpoint.gpsr.CHANGE_STATUS(payload.id, payload.statusId))
			.then((response) => response.data),
	updateGpsrServiceSettings: (payload) =>
		http.put(endpoint.gpsr.UPDATE_GPSR_SERVICE_SETTINGS(payload.id), null, {
			params: { stopNotifications: payload.stopNotifications },
		}),
	updateGpsrRemoveOnRenewal: (payload) =>
		http.put(endpoint.gpsr.REMOVE_ON_RENEWAL(payload.id), null, {
			params: { removeOnRenewal: payload.removeOnRenewal },
		}),
	downloadGpsrLastInvoice: (payload) =>
		http
			.get(endpoint.gpsr.DOWNLOAD_LAST_INVOICE(payload.id), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getGpsrInvoicesList: (payload) =>
		http.post(endpoint.gpsr.GET_INVOICES_LIST, payload).then((response) => response.data),
	downloadGpsrInvoice: (payload) =>
		http
			.get(endpoint.gpsr.DOWNLOAD_INVOICE(payload.emId, payload.invoiceId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	postGpsrReferral: (payload) => http.post(endpoint.gpsr.REFERRAL, payload),
};
